import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface ChargeWalletProps extends CacheProps {
  credit: string
}
const chargeWalletApi = ({ credit, ...rest } : ChargeWalletProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.order.charge-wallet'],
    payload: {
      creditFor: 'client',
      price: credit,
    },
    withToken: true,
    ...rest,
  });
};

export default chargeWalletApi;
